import type { Usuario } from '../types';

/**
 * Sufixo para opções de select: indica se a linha está ligada a membros como Principal e/ou Campanha.
 */
export function whatsappUsageSuffix(accountId: string, members: Usuario[]): string {
  let hasPrincipal = false;
  let hasCampanha = false;
  for (const u of members) {
    if ((u.whatsappAccountId || '').trim() === accountId) hasPrincipal = true;
    if ((u.whatsappAccountIdCampanha || '').trim() === accountId) hasCampanha = true;
  }
  const parts: string[] = [];
  if (hasPrincipal) parts.push('Principal');
  if (hasCampanha) parts.push('Campanha');
  return parts.length ? ` (${parts.join(' · ')})` : '';
}

export function formatWhatsappSelectLabel(
  account: { nome: string; telefone: string; accountId: string },
  members: Usuario[]
): string {
  return `${account.nome} — ${account.telefone}${whatsappUsageSuffix(account.accountId, members)}`;
}
